import { LazyImage } from '@components/common/image'
import TestimonialCard from '@components/common/testimonial-card'
import { scrollToTop } from '@common/utils'

const Testimonials = () => (
  <div className="flex flex-col mx-auto py-20 my-10 lg:my-20 relative">
    <LazyImage
      path="/images/book-trial-class/testimonials/"
      name="left-shapes"
      className="hidden lg:flex absolute top-0 left-0 z-10"
      alt="Background left shapes"
    />
    <LazyImage
      path="/images/book-trial-class/testimonials/"
      name="right-shapes"
      className="hidden lg:flex absolute top-0 right-0 z-10 w-1/4"
      alt="Background right shapes"
    />
    <div
      className="h-full w-full container top-0 rounded-2xl mx-auto py-20 flex flex-col"
      style={{
        backgroundColor: '#FFEBE5',
      }}
    >
      <h1 className="text-grey font-700 text-4xl w-full text-center lg:text-left lg:pl-32">
        Testimonials
      </h1>
      <div className="mx-auto z-20 flex flex-col lg:flex-row items-center lg:justify-center lg:flex-wrap max-w-6xl">
        <TestimonialCard
          name="sofia"
          imageUrl="/images/book-trial-class/testimonials/"
          content="Two weeks ago, I could not write basic code. But, just after 7 classes at Codingal, I can now build an app"
          role="Sofia"
        />
        <TestimonialCard
          name="advik"
          imageUrl="/images/book-trial-class/testimonials/"
          content="Through Codingal I realised that coding is not something very difficult and complex but actually interesting and fun!"
          role="Advik"
        />
      </div>
      <button
        className="btn btn-orange font-600 text-xl py-3 mt-20 z-10 mx-auto max-w-sm text-center"
        onClick={scrollToTop}
      >
        Book your free lesson
      </button>
    </div>
  </div>
)
export default Testimonials
